import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import UserAudit from '../UserAudit/UserAudit';
import { getBatchTypes, getBatchStatuses } from '../../../../../../Redux/Actions/CommonActions';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import UserForm from '../UserForm';

class DialogContainer extends Component {
    constructor(props) {
        super(props);
        let d = { ...this.props.dataItem };
        this.state = {
            view: "edit",
            data: Object.keys(this.props.dataItem).length === 0 ? null : d
        };
    }

    changeVeiw = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{ width: '100%' }}>
                    <div className="col-md-2 larger-font">
                        {this.state.data?
                            <ul className="subSideNav">
                                <li onClick={() => this.changeVeiw("edit")} className={this.state.view === "edit" ? "active" : ""}>Edit</li>
                                <li onClick={() => this.changeVeiw("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                            </ul>
                            :""}
                    </div>
                    <div className="col-md-10">
                        {this.state.view === "edit" ?
                            <UserForm
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                                modify={this.props.modify}
                                add={this.props.add}
                                permissions={this.props.permissions}
                            />
                                 :""} 
                        {this.state.view === "audit" ?
                            <UserAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                            : ""}    
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        common: state.common
    };
}

export default connect(mapStateToProps, {
    getBatchTypes,
    getBatchStatuses
})(DialogContainer);

